import { BaseEntity, getCachedSolarSystemEntity } from ".";

export class IndustryIndexEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Industry indices";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: any = this.props;
    const id = this._id;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      delete entity.properties["solar_system_id"];
      // - Name
      let name = "(Unknown)";
      const solarsystemEntity = await getCachedSolarSystemEntity(id);
      if (solarsystemEntity != null) {
        const resolved = await solarsystemEntity.toJson();
        if (resolved.text) {
          entity.properties["name"] = {
            type: Excel.CellValueType.string,
            basicValue: resolved.text,
          };
          name = resolved.text;
        }
      }
      entity.text = name;
      if (props.cost_indices) {
        const manufacturing = props.cost_indices.find((x: any) => x.activity == "manufacturing");
        if (manufacturing) {
          entity.properties["manufacturing"] = {
            type: Excel.CellValueType.double,
            basicValue: manufacturing.cost_index,
          };
        }
        const researching_time_efficiency = props.cost_indices.find(
          (x: any) => x.activity == "researching_time_efficiency"
        );
        if (researching_time_efficiency) {
          entity.properties["researching_time_efficiency"] = {
            type: Excel.CellValueType.double,
            basicValue: researching_time_efficiency.cost_index,
          };
        }
        const researching_material_efficiency = props.cost_indices.find(
          (x: any) => x.activity == "researching_material_efficiency"
        );
        if (researching_material_efficiency) {
          entity.properties["researching_material_efficiency"] = {
            type: Excel.CellValueType.double,
            basicValue: researching_material_efficiency.cost_index,
          };
        }
        const copying = props.cost_indices.find((x: any) => x.activity == "copying");
        if (copying) {
          entity.properties["copying"] = {
            type: Excel.CellValueType.double,
            basicValue: copying.cost_index,
          };
        }
        const invention = props.cost_indices.find((x: any) => x.activity == "invention");
        if (invention) {
          entity.properties["invention"] = {
            type: Excel.CellValueType.double,
            basicValue: invention.cost_index,
          };
        }
        const reaction = props.cost_indices.find((x: any) => x.activity == "reaction");
        if (reaction) {
          entity.properties["reaction"] = {
            type: Excel.CellValueType.double,
            basicValue: reaction.cost_index,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
